import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  SquaresFour,
  Package,
  Users,
  Calendar,
  ChartBar,
  CurrencyCircleDollar,
  MapPin,
  UserGear,
  WhatsappLogo,
  SignOut,
  X
} from '@phosphor-icons/react';
import { hasPermission } from '../../utils/permissions';
import './Sidebar.css';

const navItems = [
  { path: '/', icon: SquaresFour, label: 'Dashboard', perm: 'dashboard' },
  { path: '/orders', icon: Package, label: 'Orders', perm: 'orders' },
  { path: '/customers', icon: Users, label: 'Customers', perm: 'customers' },
  { path: '/slots', icon: Calendar, label: 'Slots', perm: 'slots' },
  { path: '/reports', icon: ChartBar, label: 'Reports', perm: 'reports' },
  { path: '/pricing', icon: CurrencyCircleDollar, label: 'Pricing', perm: 'pricing' },
  { path: '/locations', icon: MapPin, label: 'Locations', perm: 'locations' },
  { path: '/whatsapp', icon: WhatsappLogo, label: 'WhatsApp', perm: 'admin' },
  { path: '/admin', icon: UserGear, label: 'Admin', perm: 'admin' },
];

export function Sidebar({ isOpen, onClose }) {
  const navigate = useNavigate();
  const visibleItems = navItems.filter((item) => hasPermission(item.perm));

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      <aside className={`sidebar ${isOpen ? 'is-open' : ''}`}>
        <div className="sidebar-header">
          <div className="logo">
            <img src="/logo.svg" alt="WashX" className="sidebar-logo-img" />
          </div>
          <button className="sidebar-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul className="nav-list">
            {visibleItems.map((item) => (
              <li key={item.path} className="nav-item">
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `nav-link ${isActive ? 'active' : ''}`
                  }
                  onClick={onClose}
                >
                  <item.icon className="nav-icon" size={20} />
                  <span className="nav-label">{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <SignOut className="nav-icon" size={20} />
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
